import { createSlice } from '@reduxjs/toolkit';
import { secureEbookStorage } from '../../services/secureEbookStorage';

const initialState = {
  storedEbooks: [],
  accessTokens: {},
  loading: false,
  error: null,
  auditLogs: [],
};

const secureEbookStorageSlice = createSlice({
  name: 'secureEbookStorage',
  initialState,
  reducers: {
    // Armazenar eBook de forma segura
    storeEbookSecure: (state, action) => {
      const { ebookId, ebookData, userId } = action.payload;
      state.loading = true;
      state.error = null;
      
      const result = secureEbookStorage.storeEbook(ebookId, ebookData, userId);
      
      if (result.success) {
        state.accessTokens[`${ebookId}_${userId}`] = result.accessToken;
        state.storedEbooks.push({
          ebookId,
          userId,
          storedAt: new Date().toISOString(),
        });
        secureEbookStorage.logAccess(ebookId, userId, 'STORE', true);
      } else {
        state.error = result.error;
        secureEbookStorage.logAccess(ebookId, userId, 'STORE', false);
      }
      
      state.loading = false;
    },

    // Recuperar eBook de forma segura
    retrieveEbookSecure: (state, action) => {
      const { ebookId, userId, accessToken } = action.payload;
      state.loading = true;
      state.error = null;
      
      const result = secureEbookStorage.retrieveEbook(ebookId, userId, accessToken);
      
      if (result.success) {
        secureEbookStorage.logAccess(ebookId, userId, 'RETRIEVE', true);
      } else {
        state.error = result.error;
        secureEbookStorage.logAccess(ebookId, userId, 'RETRIEVE', false);
      }
      
      state.loading = false;
    },

    // Deletar eBook de forma segura
    deleteEbookSecure: (state, action) => {
      const { ebookId, userId } = action.payload;
      
      const result = secureEbookStorage.deleteEbook(ebookId, userId);
      
      if (result.success) {
        state.storedEbooks = state.storedEbooks.filter(
          e => !(e.ebookId === ebookId && e.userId === userId)
        );
        delete state.accessTokens[`${ebookId}_${userId}`];
        secureEbookStorage.logAccess(ebookId, userId, 'DELETE', true);
      } else {
        state.error = result.error;
        secureEbookStorage.logAccess(ebookId, userId, 'DELETE', false);
      }
    },

    // Listar eBooks do usuário
    listUserEbooksSecure: (state, action) => {
      const { userId } = action.payload;
      state.loading = true;
      
      const result = secureEbookStorage.listUserEbooks(userId);
      
      if (result.success) {
        state.storedEbooks = result.ebooks;
        result.ebooks.forEach(ebook => {
          state.accessTokens[`${ebook.ebookId}_${userId}`] = ebook.accessToken;
        });
      } else {
        state.error = result.error;
      }
      
      state.loading = false;
    },

    // Limpar tokens expirados
    cleanupExpiredTokens: (state, action) => {
      const { userId } = action.payload;
      secureEbookStorage.cleanupExpiredTokens(userId);
    },

    // Obter logs de auditoria
    getAuditLogs: (state, action) => {
      const { ebookId, userId } = action.payload;
      
      const result = secureEbookStorage.getAuditLogs(ebookId, userId);
      
      if (result.success) {
        state.auditLogs = result.logs;
      } else {
        state.error = result.error;
      }
    },

    // Limpar estado
    clearSecureStorage: (state) => {
      state.storedEbooks = [];
      state.accessTokens = {};
      state.loading = false;
      state.error = null;
      state.auditLogs = [];
    },
  },
});

export const {
  storeEbookSecure,
  retrieveEbookSecure,
  deleteEbookSecure,
  listUserEbooksSecure,
  cleanupExpiredTokens,
  getAuditLogs,
  clearSecureStorage,
} = secureEbookStorageSlice.actions;

export default secureEbookStorageSlice.reducer;
